import { gql } from '@apollo/client'
import { AI_CREATOR_RANK_FIELDS } from './fragments'

/** 同款榜 */
export const GET_AI_SAME_STYLE_RANK = gql`
  ${AI_CREATOR_RANK_FIELDS}
  query getAiSameStyleRank($first: Int, $offset: Int, $date: QueryDateEnum!) {
    copyrightStatisticsModule {
      rankList: userAiArtworkSameStyleRank(
        page: { first: $first, offset: $offset }
        param: { date: $date }
      ) {
        ...aiCreatorRankFields
      }
    }
  }
`
/** 作画榜 */
export const GET_AI_PICTURE_COUNT_RANK = gql`
  ${AI_CREATOR_RANK_FIELDS}
  query getAiPictureCountRank(
    $first: Int
    $offset: Int
    $date: QueryDateEnum!
  ) {
    copyrightStatisticsModule {
      rankList: userAiArtworkPictureRank(
        page: { first: $first, offset: $offset }
        param: { date: $date }
      ) {
        ...aiCreatorRankFields
      }
    }
  }
`
/** 粉丝榜 */
export const GET_AI_FANS_COUNT_RANK = gql`
  ${AI_CREATOR_RANK_FIELDS}
  query getAiFansCountRank($first: Int, $offset: Int, $date: QueryDateEnum!) {
    copyrightStatisticsModule {
      rankList: userFansRank(
        page: { first: $first, offset: $offset }
        param: { date: $date }
      ) {
        ...aiCreatorRankFields
      }
    }
  }
`
